export const model = {
    id: null,
    name: '',   

};
